"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useBreakpointIndex = require("./useBreakpointIndex");
Object.keys(_useBreakpointIndex).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBreakpointIndex[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useBreakpointIndex[key];
    }
  });
});
var _useGetMiniBagConfigurationData = require("./useGetMiniBagConfigurationData");
Object.keys(_useGetMiniBagConfigurationData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetMiniBagConfigurationData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetMiniBagConfigurationData[key];
    }
  });
});
var _useMiniBag = require("./useMiniBag");
Object.keys(_useMiniBag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useMiniBag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useMiniBag[key];
    }
  });
});
var _useTranslations = require("./useTranslations");
Object.keys(_useTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useTranslations[key];
    }
  });
});
